import React from 'react';
import { UserSettingsChangePasswordForm } from './UserSettingsChangePasswordForm';
import { UserSettingsSetPasswordForm } from './UserSettingsSetPasswordForm';
import styles from './UserSettingsSecurityForm.module.css';

export function UserSettingsSecurityForm() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Security</h2>
        <p className={styles.description}>Manage your password and security settings.</p>
      </div>

      <UserSettingsChangePasswordForm />
      <UserSettingsSetPasswordForm />
    </div>
  );
}
